import { DialogTitle } from '@radix-ui/react-dialog'
import { useShallow } from 'zustand/shallow'

import { Dialog, DialogContent, DialogHeader } from '@/components/atoms/Dialog'
import ConfigPreview from '@/components/molecules/ConfigPreview'
import EmailForm from '@/components/molecules/EmailForm'
import { useScopedI18n } from '@/locales/client'
import type { DialogTypes } from '@/stores/DialogsStore'
import useDialogsStore from '@/stores/DialogsStore'
import { useMobileLayoutStore } from '@/stores/MobileLayoutStore'
import { cn } from '@/util/cn'

const DIALOG_ID: DialogTypes = 'configurationPreview'

function ConfigPreviewDialog() {
  const t = useScopedI18n('dialogs.preview')
  const { open } = useDialogsStore(
    useShallow(state => state.dialogs.configurationPreview),
  )
  const toggle = useDialogsStore(useShallow(state => state.toggle))
  const hubId = useDialogsStore(useShallow(store => store.dialogs.configurationPreview.hubId))
  const isMobile = useMobileLayoutStore(store => store.isMobile)

  return (
    <Dialog open={open} onOpenChange={() => toggle(DIALOG_ID)}>
      <DialogContent className="inset-[initial] inset-y-0 left-0 flex max-w-3xl translate-x-0 translate-y-0 flex-col content-between items-center gap-4 p-8 text-left font-sans transition-all duration-300 ease-in-out md:inset-[initial] lg:gap-8">
        <DialogHeader>
          <DialogTitle className="mt-4 text-center font-inter text-[32px] font-bold leading-tight text-rsf-black">
            {t('title')}
          </DialogTitle>
        </DialogHeader>

        {hubId && (
          <div
            id={`config-preview-big-${hubId}`}
          >
            <ConfigPreview
              hubId={hubId}
              className={cn('config-grid mb-2 h-3/5 md:h-auto', isMobile && 'config-grid-mobile')}
              isModal
            />
          </div>
        )}

        <EmailForm
          titleText={t('formTitle')}
          buttonText={t('formButton')}
          isSingleHub
          hubId={hubId!}
        />
      </DialogContent>
    </Dialog>
  )
}

export default ConfigPreviewDialog
